import { render, staticRenderFns } from "./SNotification.vue?vue&type=template&id=977fc42a&"
import script from "./SNotification.vue?vue&type=script&lang=js&"
export * from "./SNotification.vue?vue&type=script&lang=js&"
import style0 from "./SNotification.vue?vue&type=style&index=0&id=977fc42a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports